import { getStore } from '../store/composeStore';

/**
 * Returns the composeId for the compose viewState whose draft `itemId.Id`
 * matches the provided EWS item id, or undefined if no matching viewState
 * exists. Useful when callers have an EWS item id (e.g. `parentItemId` from
 * an attachment action) and need the per-compose key used by add-in adapters.
 */
export default function getComposeIdByItemId(itemId: string): string | undefined {
    for (const viewState of getStore().viewStates.values()) {
        if (viewState.itemId?.Id === itemId) {
            return viewState.composeId;
        }
    }
    return undefined;
}
